import { useAuth0 } from "@auth0/auth0-react";
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Spin } from "antd";
import { markQboDisconnected } from "../../utils/organization";
import { isEmailVerifiedClaim } from "../../utils/auth";

/**
 * Landing page reached after the Intuit "Disconnect URL" OpenID sign-in completes.
 * Syncs our local DB state for the given realmId (Intuit already revoked the
 * OAuth tokens on their side) and redirects the user directly into Organizations,
 * where the "Connect to QuickBooks" widget is visible.
 */
const IntuitDisconnectComplete = () => {
  const { getIdTokenClaims, user } = useAuth0();
  const navigate = useNavigate();
  const hasStarted = useRef(false);

  useEffect(() => {
    if (hasStarted.current) return;
    hasStarted.current = true;

    const realmId = new URLSearchParams(window.location.search).get("realmId") || "";

    (async () => {
      try {
        const claims = await getIdTokenClaims().catch(() => null);
        if (isEmailVerifiedClaim(claims, user) === false) {
          navigate("/intuit-unverified", { replace: true });
          return;
        }
        if (claims?.__raw) {
          await markQboDisconnected(claims.__raw, realmId);
        }
      } catch (err) {
        // Best-effort: Intuit already revoked the connection on their side
      } finally {
        navigate("/organizations?disconnected=qbo", { replace: true });
      }
    })();
  }, [getIdTokenClaims, navigate, user]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-3 bg-gray-50 px-4">
      <Spin size="large" />
      <p className="text-sm text-gray-500">Disconnecting QuickBooks organization...</p>
    </div>
  );
};

export default IntuitDisconnectComplete;
